import { API_URL } from '../constants';
export const getRecipes = async (token: string, brandId: string): Promise<any> => {
  return fetch(`${API_URL}/recipes`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'brand-id': brandId,
    },
  });
};
